'use client';

import DynamicPageComponents from '@/components/dynamic/DynamicPageComponents/DynamicPageComponents';
import { PageContent } from '@/components/organisms/PageContent/PageContent';
import { notFound } from 'next/navigation';
import { generateAboutStructuredData } from './About.structuredData';
import { TLocale } from '@/types/global';
import { usePageStore } from '@/store/usePageStore';
import { localizedSlugs } from '@/i18n/routing';
import { useEffect } from 'react';

export const About = ({
  data,
  isPreview = false,
  slug,
  locale,
}: {
  data: any;
  isPreview?: boolean;
  slug?: string;
  locale?: TLocale;
}) => {
  if (!data || data.isDraft === true) {
    notFound();
  }

  const stateSelector = usePageStore;
  const setCurrentSlugTranslations = stateSelector(
    (s) => s.setCurrentSlugTranslations
  );

  useEffect(() => {
    setCurrentSlugTranslations({
      en: `/${localizedSlugs.about.en}`,
      es: `/es/${localizedSlugs.about.es}`
    })
  }, [setCurrentSlugTranslations]);

  const structuredData =
    !isPreview && slug && locale
      ? generateAboutStructuredData(data, slug, locale)
      : undefined;

  return (
    <PageContent
      pageBackground="black"
      headerBgTransparentOnStart={false}
      contentPaddingTop={'lg'}
      includePrefooterBanner={true}
      isBlockedByLogin={isPreview}
      structuredData={structuredData}
    >
      <DynamicPageComponents components={data?.components} />
    </PageContent>
  );
};
